export const GET = (seq: number): string => `
    query {
        get(seq: ${seq}) {
            title
            content,
            attachmentFileName
        }
    }
`;

export const GET_NOTICE = (keyword: string, page: number): string => `
    query {
        getNotice(keyword: "${keyword}", page: ${page}) {
            items {
                seq
                title
            }
            currentPage
            totalPage
            totalItems
        }
    }
`;
